import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Courses from './components/Courses/Container.jsx';
import Schools from './components/Schools/Container.jsx';

let hasRestplass = false;
let courseList = [];
let schoolList = [];

if (typeof courses !== 'undefined') {
    for (let i=0; i<courses.length; i++) {
        if (courses[i].r === 1) {
            hasRestplass = true;
            break;
        }
    }
    courseList = courses;
}

if (typeof schools !== 'undefined') {
    schoolList = schools;
}

const routes = () => {
    return (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={
                <Courses courses={courseList} schools={schoolList} restplassCount={hasRestplass ? '1' : '0'} lang="no" facets={window.defaultFacets} />
            }></Route>
            <Route path="/linjer/*" element={
                <Courses courses={courseList} schools={schoolList} lang="no" facets={window.defaultFacets} />
            }></Route>
            <Route path="/restplass" element={
                <Courses courses={courseList} schools={schoolList} restplassCount={hasRestplass ? '1' : '0'} lang="no" facets={window.defaultFacets} />
            }></Route>
            <Route exact path="/skoler/*" element={
                <Schools schools={schoolList} lang="no" />
            }></Route>
        </Routes>
    </BrowserRouter>
    )
};

export default routes;
